import { render, staticRenderFns } from "./PuestosSensiblesAntisoborno.vue?vue&type=template&id=2328af9c&"
import script from "./PuestosSensiblesAntisoborno.vue?vue&type=script&lang=js&"
export * from "./PuestosSensiblesAntisoborno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports